export const environment = {
  production: true,
  develop: false,
  apiURL: 'https://cms.btv-intern.de/api/v1',
  serverURL: 'https://cms.btv-intern.de',
  watermark: '',
  phoenixUri: 'https://btv.it4sport.de',
  ssePath: '/bridge',
};
